import type { ValidationCheck } from '../../types/checks.js';
import { aiManipulationCheck } from '../aiManipulationCheck.js';
import { backgroundReplacementCheck } from '../backgroundReplacementCheck.js';
import { retouchingCheck } from '../retouchingCheck.js';

/**
 * Digital-authenticity checks: retouching, AI manipulation and background
 * replacement. They are ensemble signals, never a single classifier verdict, and
 * never a legal judgement.
 */
export const AUTHENTICITY_CHECKS: readonly ValidationCheck[] = [
  retouchingCheck,
  aiManipulationCheck,
  backgroundReplacementCheck,
];
